// extracted by mini-css-extract-plugin
module.exports =  {"blocklyBuild":"RxhrkInTGusAwroSLGUD"};